import React from "react";
import DropdownSelect from "../../Atoms/DropdownSelect";

import TypographyPoppins from "@/components/Atoms/TypographyPoppins";

const ProductFilterDropdown = ({
    options,
    sortingSelectedOption,
    setSortingSelectedOption,
    label,
    width = "",
}) => {
    return (
        <div className="flex justify-between items-center">
            {label && (
                <TypographyPoppins
                    customStyle={" !text-base !capitalize "}
                    fontWeight={"normal"}
                    text={label}
                />
            )}
            <DropdownSelect
                width={width}
                options={options}
                selected={sortingSelectedOption}
                onSelect={setSortingSelectedOption}
                placeholder="Select an option"
            />
        </div>
    );
};

export default ProductFilterDropdown;
